/* istanbul ignore file */
import _ from 'underscore';
import getParams from '@bingads-webui-campaign-legacy/bulk-edit/service/get-params';

export const getBulkEditParams = (params, selectionParams) => {
  const {
    CallToAction, CallToActionLanguage, Images, BusinessName, AdStatus,
  } = params;
  const { allPages, selectedItems, filterService } = selectionParams;
  const AdditionalData = {
    BusinessName,
    Images,
    CallToAction,
    CallToActionLanguage,
    Status: AdStatus,
  };
  const batchAction = {
    Actions: [{
      PasteAs: 'MultiMediaAd',
      '@odata.type': '#Model.CopyAction',
      AdditionalData: JSON.stringify(AdditionalData),
    }],
    EditCopy: false,
  };
  const filters = _.result(filterService, 'query');
  const projection = {
    selectedIds: allPages ? [] : _.pluck(selectedItems, 'Id'),
    isSelectAll: allPages,
    filters,
    filterOptions: filterService.odataOptions,
  };
  const finalParams = getParams(projection, batchAction, 'Ad');
  return finalParams;
};

export const processViewModelDataForSaving = viewModel => ({
  CallToAction: viewModel.CallToAction.cta,
  CallToActionLanguage: viewModel.CallToAction.language,
  BusinessName: viewModel.BusinessName,
  Images: viewModel.Images,
  AdStatus: viewModel.AdStatus,
});
